(() => {
  // Unicode "grænser": ingen bogstav lige før/efter
  const BEFORE = '(?<!\\p{L})';
  const AFTER  = '(?!\\p{L})';

  function esc(s){ return s.replace(/[.*+?^${}()|[\]\\]/g,"\\$&"); }

  // Byg regex til at finde ord/fraser hvor som helst i teksten
  function buildInlineRx(terms){
    if(!terms?.length) return null;
    const parts = terms.map(t => `${BEFORE}(${esc(t)}):?${AFTER}`);
    return new RegExp(parts.join("|"), "giu");
  }

  // Regex til at fange LABEL (i starten af P) + evt. br/nbsp/kolon og samle til <strong>LABEL:</strong> værdi
  function buildParagraphStartRx(terms){
    if(!terms?.length) return null;
    const parts = terms.map(t => esc(t));
    // start af <p>: (label)(whitespace/&nbsp;)*(valgfrit kolon)*(valgfrit <br>)*(whitespace)
    return new RegExp(
      `^(?:\\s|&nbsp;)*(${parts.join("|")})(?:\\s|&nbsp;)*(?:[:：])?(?:\\s|&nbsp;)*(?:<br\\s*\\/?>)?(?:\\s|&nbsp;)*`,
      "iu"
    );
  }

  function wrapInline(root, rx){
    if(!rx) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node){
        const p = node.parentElement;
        if(!p) return NodeFilter.FILTER_REJECT;
        const tag = p.tagName.toLowerCase();
        if(["strong","b","script","style"].includes(tag)) return NodeFilter.FILTER_REJECT;
        if(!node.nodeValue?.trim()) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    while(walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(node => {
      const original = node.nodeValue;
      const text = original.replace(/\u00a0/g,' '); // NBSP -> space
      if(!rx.test(text)) return;
      rx.lastIndex = 0;

      const frag = document.createDocumentFragment();
      let last = 0, m;
      while((m = rx.exec(text)) !== null){
        const start = m.index, end = rx.lastIndex;
        if(start > last) frag.appendChild(document.createTextNode(text.slice(last, start)));
        const strong = document.createElement("strong");
        strong.textContent = text.slice(start, end);
        frag.appendChild(strong);
        last = end;
      }
      if(last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  // Saml label + kolon på samme linje når label står først i <p>
  function normalizeParagraphStarts(root, startRx){
    if(!startRx) return;
    root.querySelectorAll('p').forEach(p => {
      let html = p.innerHTML;
      if(!html) return;
      // normaliser NBSP
      html = html.replace(/\u00a0/g,'&nbsp;');
      const m = html.match(startRx);
      if(!m) return;
      const label = m[1];
      // erstat begyndelsen med <strong>LABEL:</strong> (mellemrum efter kolon)
      html = html.replace(startRx, (_, __) => `<strong>${label}</strong> `);
      // fjern evt. <br> lige efter
      html = html.replace(/^<strong>[^<]+<\/strong>\s*(?:<br\s*\/?>\s*)+/i, (s) => s.replace(/(<br\s*\/?>\s*)+/ig,''));
      p.innerHTML = html;
    });
  }

  // hvilke containere skal vi lede i (desktop + mobil/accordion)
  const SELECTORS = [
    '.rte.rte--product',
    '.product__description .rte',
    '.product__accordion .rte',
    '.collapsible-content .rte',
    '.accordion .rte',
    '.product-info .rte'
  ];

  function findRoots(){
    const out = [];
    SELECTORS.forEach(sel => document.querySelectorAll(sel).forEach(el => out.push(el)));
    return [...new Set(out)];
  }

  function run(){
    // læs ordene fra theme.liquid
    let terms = [];
    if (typeof window.MEMERY_STRONG_WORDS === 'string') {
      terms = window.MEMERY_STRONG_WORDS.split(',').map(s => s.trim()).filter(Boolean);
    }
    if(!terms.length) return;

    const inlineRx = buildInlineRx(terms);
    const startRx  = buildParagraphStartRx(terms);

    findRoots().forEach(root => {
      // undgå dobbelt-arbejde
      if (root.dataset.swProcessed === "1") return;

      normalizeParagraphStarts(root, startRx); // label først i <p>
      wrapInline(root, inlineRx);              // inline forekomster
      root.dataset.swProcessed = "1";
    });
  }

  // kør på alle måder temaer re-rendrer
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
  document.addEventListener('shopify:section:deselect', run);

  const mo = new MutationObserver(() => run());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // lille poll-fallback (fanger sene renders på mobil)
  let tries = 40;
  const poll = setInterval(() => { run(); if(--tries<=0) clearInterval(poll); }, 250);
})();
